var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurMission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m482.39 16h-81.229v42.347h81.229l-21.174-21.173z",
    fill: "#f6b600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.161 16h10v346.219h-10z",
    fill: "#397399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.801 294.974-20.236 60.148c41.293-17.049 75.528 14.264 67.431 76.228l-31.228-.354c8.944-49.475-18.975-63.189-75.491-26.734l-27.689 63.911h-31.174l42.274-99.68 34.135-94.09 79.61-27.536c11.494-3.976 18.657.745 21.245 8.209 2.573 7.421.63 17.724-11.214 22.137z",
    fill: "#397399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.792 271.778h4.947c8.922 0 26.085 13.547 26.085 22.469v73.913h-32.442v-32.498-23.108c-12.793-1.345-37.83.329-46.677 12.574l-58.416 97.9h-33.274l82.134-144.733 1.237-36.836-61.84 22.889c-26.588 9.841-31.481-22.03-15.179-28.473l84.609-33.436 27.718-18.472 68.467-75.266c4.809-5.287 28.305 17.766 11.33 36.37l-58.699 64.335z",
    fill: "#00bfa9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.61 463.133h136.217v32.867h-136.217z",
    fill: "#c90a4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.827 423.027h136.217v72.973h-136.217z",
    fill: "#fcb500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.043 362.219h136.217v133.781h-136.217z",
    fill: "#019fce"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.019,
    cy: 141.335,
    fill: "#00bfa9",
    rx: 27.942,
    ry: 27.942,
    transform: "matrix(.23 -.973 .973 .23 92.765 399.884)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.838,
    cy: 211.89,
    fill: "#397399",
    rx: 27.942,
    ry: 27.942,
    transform: "matrix(.139 -.99 .99 .139 -73.896 338.813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.521 463.133h27.305v32.867h-27.305z",
    fill: "#941234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.521 423.027h31.522v72.973h-31.522z",
    fill: "#dc9602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.521 362.219h36.739v133.781h-36.739z",
    fill: "#397399"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurMission);
export default __webpack_public_path__ + "static/media/our-mission.34c41c48c64b15598fa4f3822eb79715.svg";
export { ForwardRef as ReactComponent };